import { CHAT_INITIATIVE_OPTIONS } from '../CHAT_INITIATIVE_OPTIONS';
import { ChatInitiativeOptionIdType } from '../types';

const DEFAULT: ChatInitiativeOptionIdType = 'yes';

export const getChatInitiativeIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): ChatInitiativeOptionIdType | null => {
  const id = CHAT_INITIATIVE_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
